import styled from 'styled-components';

export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom:15px;
  font-weight: 500;
  color: #323131;
  
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #3F3F46; 
  padding:10px;
`;

export const ScrollContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  scrollbar-width: none;
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  scrollbar-width: none;    
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
`;

export const Logo = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 25px;
  float: left;
  margin-right: 10px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
`;
